import OptimizerEditDto from './OptimizerEditDto';

export class LBFGSBOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.maxcor = null;
        /** @type {number} */
        this.ftol = null;
        /** @type {number} */
        this.gtol = null;
        /** @type {number} */
        this.eps = null;
        /** @type {number} */
        this.maxfun = null;
        /** @type {number} */
        this.maxls = null;
    }

    /**
     * @typedef {Object} _LBFGSBOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} maxcor
     * @property {number} ftol
     * @property {number} gtol
     * @property {number} eps
     * @property {number} maxfun
     * @property {number} maxls
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _LBFGSBOptimizerEditDtoProps} LBFGSBOptimizerEditDtoProps
     */
    /**
     * 
     * @param {LBFGSBOptimizerEditDtoProps} props
     * @returns {LBFGSBOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.maxcor = props.maxcor;
        this.ftol = props.ftol;
        this.gtol = props.gtol;
        this.eps = props.eps;
        this.maxfun = props.maxfun;
        this.maxls = props.maxls;
        return this;
    }   
}

export default LBFGSBOptimizerEditDto;